import loadable from "src/utils/loadable";

const users = loadable(() => import("./users"));
const roles = loadable(() => import("./roles"));

export default { users, roles };
